import { ref } from '@vue/composition-api'
import L from 'leaflet'
import Marker from '@/map/marker'

export default function devicekRoute(root, device) {
  const { createCustomIcon ,createIcon } = Marker()
 
  const points = ref([])
  const line = ref(null)

  const routeLayers = L.layerGroup()

  const myRenderer = L.canvas({ padding: 0.5 });

  const lineOptions = {
    color: '#6674ff',
    weight: 5,
    opacity: 0.8,
    smoothFactor: 1,
    clickable: false
  }


  const status = {
    'moving': '#28c76f',
    'overSpeed': '#00cfe8',
    'stop': "#ea5455",
    "sweep": "#ff9f43",
    "pto": "#ff9f43",
    "off": "#b8c2cc",
    "ignitionOff": "#60008d"
  }


  /**
   *
   * @param point
   * @returns string
   */
  const getPopupRows = point => {
    return `<tr>
              <td>status: </td>
              <td>${point.status}</td>
            </tr>
            <tr>
              <td>location</td>
              <td> <a target="_blank"  href="https://maps.google.com/maps?q=${point.latitude+','+point.longitude}">${point.latitude+','+point.longitude}</a></td>
            </tr>
            <tr>
              <td>speed: </td>
              <td>${point.speed} km/h</td>
            </tr>
            <tr>
              <td>time: </td>
              <td>${point.devicetime}</td>
            </tr>`
  }

    /**
   *
   * @param point
   * @returns string
   */
    const getPopupPlaybackButton = (point, device) => {
        if(Boolean(device.has_cam)){
          return  `
          <button 
              type="button" 
              onclick="document.getElementById('app').__vue__.$camStream.startMomentPlayback({id:${device.id}, name:'${device.name}'}, '${point.devicetime}', ${15})"
              class="leaflet-popup-button"
          >
          <div class="d-flex flex-wrap w-100 align-items-center justify-content-center">
            <p class="mx-1 my-0 ">${root.$t('Cam Playback')}</p>
            <img class="mx-1" style="width: 10%; height: 10%;" src="/cam/cam-icon.svg">
          </div>
              
          </button>`

        }

        return ``
    }


  /**
   *
   * @param p
   * @returns {*}
   */
  // const createMarker = p => {
  //   const popup = `<div class="custom-popup"><table>${getPopupRows(p)}</table></div>`
  //   return L.marker([parseFloat(p.latitude), parseFloat(p.longitude)], {
  //     icon:
  //       L.divIcon({
  //         html: L.Util.template(`<span class="dot" style="opacity: 0.5;background-color:${status[p.status]}"></span>`),
  //         iconSize: [20, 20],
  //       })
  //   }).bindPopup(popup)

  // }
  const createMarker = p => {
    const popup = `
    <div class="custom-popup"> 
      <div class="header"></div>
      <table>
        ${getPopupRows(p)}
      </table>
        ${getPopupPlaybackButton(p, device.value)}
      </div>`
    return L.circleMarker([parseFloat(p.latitude), parseFloat(p.longitude)], {
      renderer: myRenderer, radius: 7, weight: 1, opacity: 0.5,
      fillOpacity: 1, color: status[p.status], fillColor: status[p.status]
    }).bindPopup(popup,{ closeButton: false})
  }

  const createDeviceMarker = p => {
  return L.marker([parseFloat(p.latitude), parseFloat(p.longitude)],
    { icon: createIcon(p) })
}

  const createColorMarker = (p, img, label, color) => {
    return L.marker([parseFloat(p.latitude), parseFloat(p.longitude)],
      { icon: createCustomIcon(img, label, color) })
  }


  /**
   *
   * @param points
   * @param map
   */
  const drawRouteLive = (points, map, array_of_filters = [],setView) => {  
    routeLayers.clearLayers()
    if (points.length > 0) {
      let routePoints = []
      const lastPointNumber = points.length;
      points.forEach((p, i) => {
        routePoints.push([points[i].latitude, points[i].longitude])
        let marker = createMarker(points[i]);
        if (array_of_filters.includes(p.status)) {
          routeLayers.addLayer(marker)
        } else {
          routeLayers.removeLayer(marker);
        }

        if (i == 0) {
          routeLayers.addLayer(createColorMarker(points[i], 'start', '', 'black'))
        }
        if (i == lastPointNumber - 1) {
          routeLayers.addLayer(createDeviceMarker(points[i]))
          if(setView){
            map.value.setView([points[i].latitude,points[i].longitude]);
          }
        

        }

      });

      // line.value = new L.Polyline(routePoints, lineOptions)

      line.value = new L.Polyline(routePoints, lineOptions)

      const arrow = L.polylineDecorator(line.value, {
        patterns: [
          {
            offset: 0, repeat: 500, symbol: L.Symbol.arrowHead(
              {
                pixelSize: 10, polygon: false, pathOptions:
                  { stroke: true, color: lineOptions.color }
              })
          }
        ]
      })

      routeLayers.addLayer(arrow)
      routeLayers.addLayer(line.value, true)
      routeLayers.addTo(map.value)
      
     
    }
  }


  const drawRoute = (points, map, array_of_filters = []) => {

    // clear route
    routeLayers.clearLayers()

    if (points.length > 0) {

      let routePoints = []


      const lastPointNumber = points.length;
      points.forEach((p, i) => {

        routePoints.push([points[i].latitude, points[i].longitude])
        let marker = createMarker(points[i]);
        if (array_of_filters.includes(p.status)) {
          routeLayers.addLayer(marker)
        } else {
          // routeLayers.addLayer(createMarkerFilterd(points[i], array_of_filters))
          routeLayers.removeLayer(marker);
        }

        if (i == 0) {


          routeLayers.addLayer(createColorMarker(points[i], 'start', '', 'black'))
        }

        if (i == lastPointNumber - 1) {
          routeLayers.addLayer(createColorMarker(points[i], 'end', '', 'black'))

        }

      });

      // line.value = new L.Polyline(routePoints, lineOptions)

      line.value = new L.Polyline(routePoints, lineOptions)

      const arrow = L.polylineDecorator(line.value, {
        patterns: [
          {
            offset: 0, repeat: 500, symbol: L.Symbol.arrowHead(
              {
                pixelSize: 10, polygon: false, pathOptions:
                  { stroke: true, color: lineOptions.color }
              })
          }
        ]
      })

      routeLayers.addLayer(arrow)
      routeLayers.addLayer(line.value, true)
      routeLayers.addTo(map.value)
   
      map.value.fitBounds(line.value.getBounds())
    }
  }



  const drawRouteForOnepoint = (points, map,point_id) => {
    // clear route
    routeLayers.clearLayers()
    let oneMaker=null
    if (points.length > 0) {
    
      let routePoints = []
      const lastPointNumber = points.length;
        points.forEach((p, i) => {       
        routePoints.push([points[i].latitude, points[i].longitude])
        let marker = createMarker(points[i]);
        if ( point_id==p.id) {
           oneMaker = createMarker(points[i]);
          routeLayers.addLayer(oneMaker)
         
        } else {
          // routeLayers.addLayer(createMarkerFilterd(points[i], array_of_filters))
          routeLayers.removeLayer(marker);
        }

        if (i == 0) {
          routeLayers.addLayer(createColorMarker(points[i], 'start', '', 'black'))
        }

        if (i == lastPointNumber - 1) {
          routeLayers.addLayer(createColorMarker(points[i], 'end', '', 'black'))

        }

      });

      // line.value = new L.Polyline(routePoints, lineOptions)

      line.value = new L.Polyline(routePoints, lineOptions)

      const arrow = L.polylineDecorator(line.value, {
        patterns: [
          {
            offset: 0, repeat: 500, symbol: L.Symbol.arrowHead(
              {
                   pixelSize: 10, polygon: false, pathOptions:
                  { stroke: true, color: lineOptions.color }
              })
          }
        ]
      })

      routeLayers.addLayer(arrow)
      routeLayers.addLayer(line.value, true)
      routeLayers.addTo(map.value)
       //map.value.setZoom(2);
       if(oneMaker!==null){
        oneMaker.openPopup();
      map.value.setView(oneMaker.getLatLng(), 17);
      map.value.flyTo(oneMaker.getLatLng());
       }else{
         root.$bvToast.toast(root.$i18n.t("unable to find point"), {
          title: root.$i18n.t("Error Unable to find point"),
          variant: 'danger',
          solid: false,
        })
       }
     
     // map.value.fitBounds(line.value.getBounds())
  
    }
  }

  return {
    drawRoute,
    drawRouteLive,
    drawRouteForOnepoint,
    points,
    line,
    lineOptions
  }
}

